module.exports = __webpack_public_path__ + "static/teilnehmer-sicht-02-d64d109d374763730f5495934ee6f6d3.png";